import { Segment } from '../../../services/analytics-services/segment';
import {
  EXPORT_BALANCE_HISTORY_CLICK,
  EXPORT_BALANCE_HISTORY_COMPLETE,
  VIEW_BALANCE_HISTORY_START,
} from '../../../constants/analytics-events';

export const trackViewBalanceHistoryStart = (walletId, params) => {
  const filterSorts = JSON.stringify(params);
  Segment.trackEvent(VIEW_BALANCE_HISTORY_START, {
    walletId,
    filterSorts,
  });
};

export const trackExportBalanceHistoryStart = (walletId, jobGuid, params) => {
  const filterSorts = JSON.stringify(params);
  Segment.trackEvent(EXPORT_BALANCE_HISTORY_CLICK, {
    walletId,
    jobGuid,
    filterSorts,
  });
};

export const trackExportBalanceHistoryComplete = (walletId, jobGuid, recordCount = 0, hasError = false) => {
  Segment.trackEvent(EXPORT_BALANCE_HISTORY_COMPLETE, {
    walletId,
    jobGuid,
    recordCount,
    hasError,
  });
};
